/* eslint-disable */
import React, { useCallback, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link, useHistory } from 'react-router-dom'
import dayjs from 'dayjs'
import qs from 'qs'
import { Tabs, Button, Modal, Avatar, Table, Divider, Breadcrumb, Tooltip, Input } from 'antd'
import * as actions from '@/models/referrals/actions'
import * as selectors from '@/models/referrals/selectors'
import styles from './referrals.module.scss'
import InvitationsDialog from '@/components/dialogs/InvitationsDialog'
import ReferalRule from '@/containers/referalRule'

function getColumns(reFetch) {
  const dispatch = useDispatch()
  const history = useHistory()
  const navToSettlement = id => {
    history.push(`/referrals/${id}/settlement`)
  }

  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '推广员',
      render: item => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: 10 }}>
            <Avatar shape="square" size={42} src={item?.user?.avatar} />
          </div>
          <div>
            <div>{item?.user?.name}</div>
            <div>
              <small style={{ color: '#b2b2b2' }}>{item?.realname}</small>
              <small style={{ color: '#b2b2b2' }}>{item?.user?.mobile}</small>
            </div>
          </div>
        </div>
      )
    },
    {
      title: '已结算总佣金',
      render: item => (
        <div>
          <h3>¥{item.amount?.toFixed(2)}</h3>
        </div>
      )
    },
    {
      title: '之前月份未结算',
      render: item => (
        <div>
          <h3>¥{item.no_amount?.toFixed(2)}</h3>
        </div>
      )
    },
    {
      title: '本月佣金',
      render: item => (
        <div>
          <h3>¥{item.mamount?.toFixed(2)}</h3>
        </div>
      )
    },
    {
      title: '最近结算于',
      render: item => (
        <div>
          <div>{dayjs(item.lastSettlementAt).fromNow()}</div>
          <small style={{ color: '#b2b2b2' }}>{dayjs(item.lastSettlementAt).format('YYYY-MM-DD HH:mm')}</small>
        </div>
      )
    },
    // {
    //   title: '关联企业',
    //   render: item => (
    //     <div className={styles.tenantList}>
    //       {
    //         item.refs.map(ref => (
    //           <span className={styles.compnayItem} key={ref._id}>
    //             <Divider>
    //               <Avatar shape="square" size={30} src={ref?.tenant?.logo} style={{ marginLeft: 5 }} />
    //             </Divider>
    //             <div>
    //               <div>
    //                 <span style={{ whiteSpace: 'pre' }}>绑定企业：</span>
    //                 {ref?.tenant.short_name}
    //               </div>
    //               <div>
    //                 <span style={{ whiteSpace: 'pre' }}>结算类型：</span>
    //                 {ref?.type === 1 ? `每单固定${ref.per_order_commission}元` : `每单毛利的${(ref.per_order_commission_rate * 100)?.toFixed(0)}%`}
    //               </div>
    //               <div>最后结算：{dayjs(ref.lastSettlementAt).format('YYYY-MM-DD HH:mm')}</div>
    //               <div>关联时间：{dayjs(ref.createdAt).format('YYYY-MM-DD HH:mm')}</div>
    //               <div>使用延期规则：{ref.useRule ? '是' : '否'}</div>
    //               <div>提成期限：{ref.lastBrokerageAt ? dayjs(ref.lastBrokerageAt).format('YYYY-MM-DD HH:mm') : '无限期'}</div>
    //             </div>

    //           </span>
    //         ))
    //       }
    //     </div>
    //   )
    // },
    {
      title: '操作',
      render: item => {
        // 仅允许结算30天以前的账单（即最多每月结算一次）
        const enable = Date.now() - new Date(item.lastSettlementAt).getTime() > 1 //000 * 60 * 60 * 24 * 30
        const showLinkDialog = () => {
          dispatch(actions.showLinkListDialog({
            title: `推广员 - ${item.realname} - 企业关联表`,
            referral: item,
            refreshList: reFetch
          }))
        }

        const showBindDialog = () => {
          dispatch(actions.showBindDialog({
            title: `推广员 - ${item.realname} - 新增关联`,
            referral: item,
            successCallback: reFetch
          }))
        }

        const showManagerListDialog = () => {
          dispatch(actions.showManagerListDialog({
            title: `管理分佣关系`,
            referral: item,
            refreshList: reFetch
          }))
        }
        return (
          <div>
            {
              !enable ? (
                <Button onClick={() => navToSettlement(item._id)} type="primary">结算</Button>
              ) : (
                <a onClick={() => navToSettlement(item._id)} type="link">查看对账单</a>
              )
            }

            <div style={{ marginTop: 10 }}>
              <a onClick={showLinkDialog}>查看关联表</a>
              <Divider type="vertical" />
              <a onClick={showBindDialog}>新增关联</a>
            </div>
            <div style={{ marginTop: 10 }}>
              <a onClick={showManagerListDialog}>管理关联关系</a>
            </div>
          </div>
        )
      }
    }
  ]
}

function getRetailColumns(reFetch) {
  const dispatch = useDispatch()
  const history = useHistory()
  const navToRetailSettlement = id => {
    history.push(`/referrals/${id}/retailSettlement`)
  }

  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '推广员',
      render: item => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: 10 }}>
            <Avatar shape="square" size={42} src={item?.user?.avatar} />
          </div>
          <div>
            <div>{item?.user?.name}</div>
            <div>
              <small style={{ color: '#b2b2b2' }}>{item?.realname}</small>
              <small style={{ color: '#b2b2b2' }}>{item?.user?.mobile}</small>
            </div>
          </div>
        </div>
      )
    },
    {
      title: '已结算总佣金',
      render: item => (
        <div>
          <h3>¥{item.amount?.toFixed(2)}</h3>
        </div>
      )
    },
    {
      title: '之前月份未结算',
      render: item => (
        <div>
          <h3>¥{item.no_amount?.toFixed(2)}</h3>
        </div>
      )
    },
    {
      title: '本月佣金',
      render: item => (
        <div>
          <h3>¥{item.mamount?.toFixed(2)}</h3>
        </div>
      )
    },
    {
      title: '最近结算于',
      render: item => (
        <div>
          <div>{dayjs(item.lastSettlementAt).fromNow()}</div>
          <small style={{ color: '#b2b2b2' }}>{dayjs(item.lastSettlementAt).format('YYYY-MM-DD HH:mm')}</small>
        </div>
      )
    },
    {
      title: '操作',
      render: item => {
        // 仅允许结算30天以前的账单（即最多每月结算一次）
        const enable = Date.now() - new Date(item.lastSettlementAt).getTime() > 1 //000 * 60 * 60 * 24 * 30
        const showRetailLinkDialog = () => {
          dispatch(actions.showRetailLinkListDialog({
            title: `推广员 - ${item?.realname || item?.user?.mobile} - 用户关联表1`,
            retail: item,
            refreshList: reFetch
          }))
        }

        const showRetailBindDialog = () => {
          dispatch(actions.showRetailBindDialog({
            title: `推广员 - ${item.realname || item?.user?.mobile} - 新增关联`,
            referral: item,
            successCallback: reFetch
          }))
        }

        const showRetailManagerListDialog = () => {
          console.log(123)
          dispatch(actions.showRetailManagerListDialog({
            title: `管理分佣关系`,
            referral: item,
            refreshList: reFetch
          }))
        }

        return (
          <div>
            {
              !enable ? (
                <Button onClick={() => navToRetailSettlement(item._id)} type="primary">结算</Button>
              ) : (
                <a onClick={() => navToRetailSettlement(item._id)} type="link">查看对账单</a>
              )
            }
            <Divider type="vertical" />
            <a onClick={showRetailLinkDialog}>查看关联表</a>
            <div style={{ marginTop: 10 }}>
              <a onClick={showRetailManagerListDialog}>管理关联关系</a>
              <Divider type="vertical" />
              <a onClick={showRetailBindDialog}>新增关联</a>
            </div>
            {/* <div style={{ marginTop: 10 }}>
              <a onClick={showRetailLinkDialog}>查看关联表</a>
              <Divider type="vertical" />
              <a onClick={showRetailBindDialog}>新增关联</a>
            </div> */}
          </div>
        )
      }
    }
  ]
}

function ReffList(props) {
  const dispatch = useDispatch()

  const loading = useSelector(selectors.loadingSelector)
  const total = useSelector(selectors.totalSelector)
  const items = useSelector(selectors.entriesSelectors)

  const [activeKey, setActiveKey] = useState(1)
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const ruleRef = useRef(null);
  const [keyword, setKeyword] = useState(null);

  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }

  const fetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    if (keyword && !params.keyword) {
      params.keyword = keyword
    }
    setLimit(params.limit)
    setOffset(params.offset)
    dispatch(actions.fetchList(params))
  }, [keyword])

  const retailFetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    if (keyword && !params.keyword) {
      params.keyword = keyword
    }
    setLimit(params.limit)
    setOffset(params.offset)
    dispatch(actions.fetchRetailList(params))
  }, [keyword])

  const showInvtDialog = useCallback((title) => () => {
    dispatch(actions.showInvtDialog({
      title
    }))
  }, [])

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize,
      keyword: keyword || null
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    console.log('handleTableChange nextQuery',nextQuery)
    fetch(nextQuery)
  }, [keyword])

  const handleRetailTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize,
      keyword: keyword || null
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    console.log('nextQuery',nextQuery)
    retailFetch(nextQuery)
  }, [keyword])

  const columns = getColumns(fetch)
  const retailColumns = getRetailColumns(retailFetch)

  useMount(() => {
    console.log('use Mount',activeKey)
    fetch()
  })
  const operations = (<>
    {/* {activeKey == 1 && <Button size="small" onClick={showInvtDialog('添加推广员')}>添加推广员</Button>} */}
    {activeKey == 2 && <Button size="small" onClick={() => { ruleRef?.current?.add(); }}>添加规则</Button>}
  </>)
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>佣金返利</Breadcrumb.Item>
          {/* <Breadcrumb.Item>列表</Breadcrumb.Item> */}
        </Breadcrumb>
        {/* <Button size="small" onClick={showInvtDialog('添加推广员')}>添加推广员</Button> */}
      </div>
      <div className={styles.content}>
        <Tabs type="card" tabBarExtraContent={operations} onChange={(key) => { 
          setActiveKey(key);
          // 根据 key 调用相应的请求函数
          if (key === "1") {
            fetch();
          } else if (key === "3") {
            retailFetch();
          }
        }}>
          <Tabs.TabPane tab="推广员" key="1">
            <div>
              <Input.Search
                allowClear
                enterButton
                placeholder="请输入"
                onSearch={value => {
                  setKeyword(value || null);
                  fetch({ keyword: value || null })
                }}
                style={{ width: 300 }}
              />
            </div>
            <Table
              className={styles.table}
              columns={columns}
              rowKey="_id"
              dataSource={items.toJS()}
              pagination={pagination}
              onChange={handleTableChange}
              loading={loading}></Table>
          </Tabs.TabPane>
          <Tabs.TabPane tab="延期规则" key="2">
            <ReferalRule ref={ruleRef} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="散户" key="3">
            <div>
              <Input.Search
                allowClear
                enterButton
                placeholder="请输入"
                onSearch={value => {
                  setKeyword(value || null);
                  retailFetch({ keyword: value || null })
                }}
                style={{ width: 300 }}
              />
            </div>
            <Table
              className={styles.table}
              columns={retailColumns}
              rowKey="_id"
              dataSource={items.toJS()}
              pagination={pagination}
              onChange={handleRetailTableChange}
              loading={loading}></Table>
          </Tabs.TabPane>
        </Tabs>
      </div>
      <InvitationsDialog type="referral" />
    </div>
  )
}

export default ReffList
